import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';

import {
  fetchAnnualReportsRequest,
  fetchAnnualReportsSuccess,
  fetchAnnualReportsError,
  generateAnnualReportRequest,
  generateAnnualReportSuccess,
  generateAnnualReportError,
  submitAnnualReportRequest,
  submitAnnualReportSuccess,
  submitAnnualReportError,
  removeAnnualReportRequest,
  removeAnnualReportSuccess,
  removeAnnualReportError,
  fetchReportCommentsRequest,
  fetchReportCommentsSuccess,
  fetchReportCommentsError,
} from './index';
import {
  fetchAnnualReports,
  generateAnnualReport,
  submitAnnualReport,
  removeAnnualReport,
  fetchReportComments,
} from './api';

export const sagaActions = {
  FETCH_ANNUAL_REPORTS: 'FETCH_ANNUAL_REPORTS',
  GENERATE_ANNUAL_REPORTS: 'GENERATE_ANNUAL_REPORTS',
  SUBMIT_ANNUAL_REPORT: 'SUBMIT_ANNUAL_REPORT',
  REMOVE_ANNUAL_REPORT: 'REMOVE_ANNUAL_REPORT',
  FETCH_REPORT_COMMENTS: 'FETCH_REPORT_COMMENTS',
};

function* fetchAnnualReportsSaga({payload}) {
  try {
    yield put(fetchAnnualReportsRequest());
    const result = yield call(fetchAnnualReports, payload);
    if (!result.error) {
      yield put(fetchAnnualReportsSuccess(result.data));
    } else {
      yield put(fetchAnnualReportsSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchAnnualReportsError(message));
    } else {
      toast.error(e.error);
      yield put(fetchAnnualReportsError(e.error));
    }
  }
}

function* generateAnnualReportSaga({payload}) {
  try {
    yield put(generateAnnualReportRequest());
    const result = yield call(generateAnnualReport, payload);
    if (!result.error) {
      toast.success(result.message);
      yield put(generateAnnualReportSuccess(result.data));
    } else {
      toast.error(result.error);
      yield put(generateAnnualReportError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(generateAnnualReportError(message));
    } else {
      toast.error(e.error);
      yield put(generateAnnualReportError(e.error));
    }
  }
}

function* submitAnnualReportSaga({payload}) {
  try {
    yield put(submitAnnualReportRequest());
    const result = yield call(submitAnnualReport, payload);
    if (!result.error) {
      toast.success(result.message);
      yield put(submitAnnualReportSuccess(result.data));
    } else {
      toast.error(result.error);
      yield put(submitAnnualReportError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(submitAnnualReportError(message));
    } else {
      toast.error(e.error);
      yield put(submitAnnualReportError(e.error));
    }
  }
}

function* removeAnnualReportSaga({payload}) {
  try {
    yield put(removeAnnualReportRequest());
    const result = yield call(removeAnnualReport, payload);
    if (!result.error) {
      toast.success(result.message);
      yield put(removeAnnualReportSuccess(result.data));
    } else {
      toast.error(result.error);
      yield put(removeAnnualReportError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(removeAnnualReportError(message));
    } else {
      toast.error(e.error);
      yield put(removeAnnualReportError(e.error));
    }
  }
}

function* fetchReportCommentsSaga({payload}) {
  const {values, reportId} = payload;
  try {
    yield put(fetchReportCommentsRequest());
    const result = yield call(fetchReportComments, reportId, values);
    if (!result.error) {
      yield put(
        fetchReportCommentsSuccess({
          reportId,
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      // toast.error(result.error);
      yield put(
        fetchReportCommentsSuccess({
          reportId: 0,
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      // toast.error(message);
      yield put(fetchReportCommentsError(message));
    } else {
      // toast.error(e.error);
      yield put(fetchReportCommentsError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.FETCH_ANNUAL_REPORTS, fetchAnnualReportsSaga);
  yield takeLatest(
    sagaActions.GENERATE_ANNUAL_REPORTS,
    generateAnnualReportSaga
  );
  yield takeLatest(sagaActions.SUBMIT_ANNUAL_REPORT, submitAnnualReportSaga);
  yield takeLatest(sagaActions.REMOVE_ANNUAL_REPORT, removeAnnualReportSaga);
  yield takeLatest(sagaActions.FETCH_REPORT_COMMENTS, fetchReportCommentsSaga);
}

export default rootSagas;
